/**
 * 플랜의 뷰어 댓글 허용 (PRD2 `viewer_can_comment`, 기본 끔).
 */

import { useSyncExternalStore } from "react";

const KEY = "plan-viewer-comment-v1";

let map: Record<string, boolean> = read();
let version = 0;
const listeners = new Set<() => void>();

function read(): Record<string, boolean> {
  if (typeof localStorage === "undefined") return {};
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as Record<string, unknown>;
    const next: Record<string, boolean> = {};
    for (const [id, value] of Object.entries(parsed)) {
      if (value === true) next[id] = true;
    }
    return next;
  } catch {
    return {};
  }
}

function emit() {
  version += 1;
  if (typeof localStorage !== "undefined") localStorage.setItem(KEY, JSON.stringify(map));
  for (const listener of listeners) listener();
}

export function resetPlanViewerComment(): void {
  map = {};
  if (typeof localStorage !== "undefined") localStorage.removeItem(KEY);
  emit();
}

export function planViewerCommentOf(id: string | null | undefined): boolean {
  if (!id) return false;
  return map[id] === true;
}

export function setPlanViewerComment(id: string, value: boolean): void {
  if (!id) return;
  map = { ...map, [id]: value };
  emit();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function usePlanViewerComment(id: string | null | undefined): boolean {
  useSyncExternalStore(subscribe, () => version, () => version);
  return planViewerCommentOf(id);
}
